<template>
	<FloatingNotification
		:class="[
			'desktop-optimized-notification',
			desktopOptimized && 'is-available'
		]"
		v-if="desktopOptimized"
		messageText="Screen is not optimized for use on screen sizes smaller than desktop."
		state="warning"
		iconClassName="icon-warning-01"
		:expanded="true"
		:disabled="disabled"
		ref="floatingNotification"
	/>
</template>

<script>
import baseComponentMixin from '@/mixins/base-component-mixin';
import FloatingNotification from '@/components/notifications/floating-notification/floating-notification.vue';

export default {
	name: 'DesktopOptimizedNotification',
	mixins: [baseComponentMixin],
	components: { FloatingNotification },
	computed: {
		desktopOptimized() {
			let desktopOptimized = false;

			if (this.$route && this.$route.meta) {
				desktopOptimized = this.$route.meta.desktopOptimized || false;
			}

			return desktopOptimized;
		}
	}
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
  #BASE-COMPONENT-STYLES
  The base class and variant classes, if applicable, are never added/removed via dev logic.
\*------------------------------------*/
.desktop-optimized-notification {
	&.is-available {
		@include mq($from: lg) {
			display: none;
		}
	}
}
</style>
